export default "__VITE_ASSET__F4KoxG7Z__"